import { Component, TemplateRef, ViewChild } from '@angular/core';
import { environment } from './../environments/environment';
import { CredentialsService } from './authentication/credentials.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { interval, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CountdownComponent } from 'ngx-countdown';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'vov-ui';
  apiUrl = environment.apiUrl;
  name = environment.title;
  idletimeSubscription: Subscription;
  idletimeSubscription1: Subscription;
  subscription: Subscription;
  public timeout = 14;
  _setTimeOut: any;
  public formDialog: MatDialogRef<any> = null;
  public confirmDialog: MatDialogRef<any> = null;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;
  @ViewChild('countdown') counter: CountdownComponent;
  constructor(private credentialService: CredentialsService,
    private bnIdle: BnNgIdleService,
    private bnIdle1: BnNgIdleService,
    private router: Router,
    public dialog: MatDialog,
  ) { }
  ngOnInit() {
    console.log("App is started***")
    const source = interval(1000);
    this.subscription = source.subscribe(val => this.autoExpiry());
    this.credentialService.onUserAuth.subscribe(
      (res) => {
        if (res) {
          this.idletimeSubscription = this.bnIdle.startWatching(this.timeout * 60).subscribe(async (res) => {
            if (res) {
              if (this.counter != undefined && this.counter.i.text) {
                this.logOut();

              } else {
                this.confirmDialog = this.dialog.open(this.confirmRef, {
                  width: '600px',
                  data: 'data'
                });
                this.confirmDialog.disableClose = true;
              }
              // if (confirm("Are you sure to delete this tag")) {
              // console.log('Im watching you...buddy..')
              // sessionStorage.removeItem('currentUser');
              // localStorage.removeItem('currentUser');
              // this.router.navigate(['/sign-in'], { replaceUrl: true });
            }
            // }
          });
        } else {
          if (this.bnIdle) this.bnIdle.stopTimer();
          if (this.idletimeSubscription) {
            this.idletimeSubscription.unsubscribe();
          }
        }
      }
    )

  }
  autoExpiry() {
    console.log("Auto Expiry startted***")
    if (this.counter != undefined) {
      console.log('Timer**', this.counter.i.text);
    }

    if (this.counter != undefined && this.counter.i.text == "00") {
      this.logOut();
      return;
    }
    // this._setTimeOut = setTimeout(async () => {
    const currentLocalUser = localStorage.getItem('currentUser');
    const currentSessionUser = sessionStorage.getItem('currentUser');
    if ((currentLocalUser == null || currentLocalUser == undefined) && (currentSessionUser != null || currentSessionUser != undefined)) {
      sessionStorage.setItem('isloggedIn','true');
      sessionStorage.removeItem('currentUser');
      localStorage.removeItem('currentUser');
      if (this.router.url == "/enforcement" || this.router.url == "/create-case" || this.router.url == "/expired-case" || this.router.url == "/case-listing") {
        this.router.navigate(['/code-sign-in'], { replaceUrl: true });
      } else {
        this.router.navigate(['/sign-in'], { replaceUrl: true });
      }
    } else if((currentLocalUser == null || currentLocalUser == undefined) && (currentSessionUser == null || currentSessionUser == undefined)){
      const isloggedIn = sessionStorage.getItem('isloggedIn');
      if(isloggedIn){
        sessionStorage.removeItem('isloggedIn');
        if (this.router.url == "/enforcement" || this.router.url == "/create-case" || this.router.url == "/expired-case" || this.router.url == "/case-listing") {
          this.router.navigate(['/code-sign-in'], { replaceUrl: true });
        } else {
          this.router.navigate(['/sign-in'], { replaceUrl: true });
        }
      }
    }
    // else if ((currentLocalUser == null || currentLocalUser == undefined) && (currentSessionUser == null || currentSessionUser == undefined)) {
    //   sessionStorage.removeItem('currentUser');
    //   localStorage.removeItem('currentUser');
    //   if (this.router.url == "/enforcement" || this.router.url == "/create-case" || this.router.url == "/expired-case" || this.router.url == "/case-listing") {
    //     this.router.navigate(['/code-sign-in'], { replaceUrl: true });
    //   } else {
    //     this.router.navigate(['/sign-in'], { replaceUrl: true });
    //   }
    // }
    // this.autoExpiry();
    // }, 1000);
  }

  onNoClick() {
    this.confirmDialog.close();
  }
  logOut() {
    sessionStorage.removeItem('currentUser');
    localStorage.removeItem('currentUser');

    // this.counter.pause()
    if (this.bnIdle1) this.bnIdle.stopTimer();
    if (this.idletimeSubscription1) {
      this.idletimeSubscription1.unsubscribe();
    }

    if (this.bnIdle) this.bnIdle.stopTimer();
    if (this.idletimeSubscription) {
      this.idletimeSubscription.unsubscribe();
    }
    this.confirmDialog.close();
    this.dialog.closeAll();
    if (this.router.url == "/enforcement" || this.router.url == "/create-case" || this.router.url == "/expired-case" || this.router.url == "/case-listing") {
      this.router.navigate(['/code-sign-in'], { replaceUrl: true });
    } else {
      this.router.navigate(['/sign-in'], { replaceUrl: true });
    }
    // console.log('............',this.router.url);

  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

}

